import PillLink from './PillLink';

export default PillLink;
